<div class="portal--header">
  <h1 class="heading">Users</h1>
  <form action="" class="std-form form__search">
    <label for="input-addon">Search</label>
    <div class="input-addon input-addon__btn-side">
      <select title="Search Type" name="searchType" id="" class="" style="background-color: white; color: black; width: 10rem;" (change)="updateSearchType($event.target.value)" #searchType>
        <option value="email">Email</option>
        <option value="lastname">Last Name</option>
      </select>
      <input type="text" id="input-addon" class="input-addon__btn-side--input" placeholder="Search..." name="searchTerm" (keyup)="searchUpdated($event.target.value)" #searchInput>
      <button (click)="search()" class="std-btn input-addon__btn-side--btn focus-element"><span class="focus--content" tabindex="-1">Find</span></button>
    </div>
  </form>
</div>
<div class="portal--main">
  <div class="flex-grid space-between bottom">
    <div class="flex-grid--item">
      <div class="btn-group">
        <a [routerLink]="['/portal/admin/user', 'new']" class="std-btn focus-element visible-sm visible-md visible-lg"><span class="focus--content" tabindex="-1">Add new user</span></a>
        <a [routerLink]="['/portal/admin/user', 'new']" class="std-btn focus-element hidden-sm hidden-md hidden-lg"><span class="focus--content" tabindex="-1">Add</span></a>
      </div>
    </div>    
  </div>
  <div class="module-wrapper">
    <div class="module drop-shadow bottom">
      <h3 *ngIf="isSearching">Searching...</h3>
      <p *ngIf="!isSearching && results.length == 0" class="text-center">No matching results</p>
      <table *ngIf="!isSearching && results.length > 0" class="std-table stacked-sm">
        <thead>
        <th>First name</th>
        <th>Last name</th>
        <th>Email</th>
        <th></th></thead>
        <tbody>
          <tr *ngFor="let result of results">
            <td data-label="First name">{{result.firstName}}</td>
            <td data-label="Last name">{{result.lastName}}</td>
            <td data-label="Email">{{result.email}}</td>
            <td class="text-right"><a [routerLink]="['/portal/admin/user', result.id]" class="focus-element text-link"><span class="focus--content">Edit</span></a></td>
          </tr>
        </tbody>
      </table>
      <app-pagination *ngIf="!isSearching" [page]="page" [pages]="totalPages" (pageChange)="pageSelected($event)"></app-pagination>
    </div>
  </div>
</div>
